import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { UpdateFeatureMasterModel } from '../vo/update-feature-master-info-request.model';
import { KYMW4500Model } from '../kymw4500.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * 特集マスタ情報更新
 *
 * @export UpdateFeatureMasterInfoService
 * @class UpdateFeatureMasterInfoService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class UpdateFeatureMasterInfoService extends PlessJsonResponderSub<any> {
  private request: UpdateFeatureMasterModel[];
  private successFunc: Function;
  private kymw4500Model: KYMW4500Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateFeatureMasterInfoService
   */
  private getBody(): PlessRequest {
    // 特集リスト
    const featureList = Array.from(this.request).map(_ => {
      return {
        parameter: {
          FeatureCode: _.FeatureCode,
          FeatureName: _.FeatureName,
          ApprovalFlowType: _.ApprovalFlowType,
          NotificationUserId: _.NotificationUserId,
          PlannerSelectionFlag: _.PlannerSelectionFlag,
          AssociatedCompanyId: _.AssociatedCompanyId,
          Remarks: _.Remarks,
          FeaturePerMediaFlag: _.FeaturePerMediaFlag
        }
      }
    });
    let featureTagList = [];
    let featurePayeeSupplierList = [];
    this.request.forEach(_ => {
      // 特集コード毎のタグIDのリスト
      if(!PlessViewUtilsSub.isEmptyArray(_.TagList)) {
        const tagList = _.TagList.map(tag => {
          return {
            parameter: {
              FeatureCode: _.FeatureCode,
              TagId: tag.TagId
            }
          }
        });
        featureTagList.push(...tagList);
      }
      // 特集コード毎の支払先取引先IDのリスト
      if(!PlessViewUtilsSub.isEmptyArray(_.PayeeSupplierList)) {
        const payeeSupplierList = _.PayeeSupplierList.map(payeeSupplier => {
          return {
            parameter: {
              FeatureCode: _.FeatureCode,
              PayeeSupplierCode: payeeSupplier.PayeeSupplierCode
            }
          }
        });
        featurePayeeSupplierList.push(...payeeSupplierList);
      }
    });

    return new PlessRequest({
      regist: {
        RegistFeatureMaster: {
          combination: featureList.length === 0 ? [
            {
              parameter: {
                FeatureCode: null,
                FeatureName: null,
                ApprovalFlowType: null,
                NotificationUserId: null,
                PlannerSelectionFlag: null,
                AssociatedCompanyId: null,
                Remarks: null,
                FeaturePerMediaFlag: null
              }
            }
          ] : featureList,
          condition: {
            OrderCode: this.kymw4500Model.orderCode,
            MediumType: this.kymw4500Model.mediumType,
            ExclusiveDatetime: this.kymw4500Model.exclusiveDatetime
          }
        },
        TagList: {
          combination: featureTagList.length === 0 ? [
            {
              parameter: {
                FeatureCode: null,
                TagId: null
              }
            }
          ] : featureTagList
        },
        PayeeSupplierList: {
          combination: featurePayeeSupplierList.length === 0 ? [
            {
              parameter: {
                FeatureCode: null,
                PayeeSupplierCode: null
              }
            }
          ] : featurePayeeSupplierList
        }
      }
    });
  }

  /**
   * API呼び出し
   * @param model
   * @param successFunc
   * @memberof UpdateFeatureMasterInfoService
   */
  execute(request: UpdateFeatureMasterModel[], kymw4500Model: KYMW4500Model, successFunc: Function = null): void {
    this.request = request;
    this.kymw4500Model = kymw4500Model;
    this.successFunc = successFunc;
    this.send('updateFeatureMasterInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateFeatureMasterInfoService
   */
  success(data: any) {
    if (this.successFunc) this.successFunc();
  }
}
